import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Icon,
  Image,
  SimpleGrid,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { BiDownload, BiLinkExternal } from "react-icons/bi";
import { MdLocationOn, MdMicExternalOn } from "react-icons/md";
import { api } from "../../services/api";

interface IPhoto {
  _id: string;
  filename: string,
  latitude: number,
  longitude: number
}

interface Props {
  photo: {
    _id: string;
    filename: string,
    latitude: number,
    longitude: number
  }
  openModal: () => void
}

export function ImagePreview({photo, openModal}: Props) {
  const [showButtons, setShowButtons] = useState(false);


  const openOriginalImagem = (imageUrl: string) => {
    window.open(imageUrl, '_blank')
  }

  const downloadImage = async () => {
    try {
      const response = await api.get(`photo?url=${`https://qth-files.s3.sa-east-1.amazonaws.com/${photo.filename}`}`, {responseType: 'blob'})

      const blob = new Blob([response.data], { type: response.headers['content-type'] });



      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${photo.filename}.jpg`;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Erro ao fazer download da imagem:', error);
    }
  };

  return (
    <div 
      key={photo._id}
      onMouseEnter={() => setShowButtons(true)}
      onMouseLeave={() => setShowButtons(false)}
      style={{ position: 'relative', display: 'inline-block', margin: '10px', cursor: 'pointer' }}

    >
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Image 
          src={`https://qth-files.s3.sa-east-1.amazonaws.com/${photo.filename}`} 
          boxSize="350px" 
          _hover={{
            cursor: 'pointer'
          }} 
        />

        {showButtons && (
          <div 
            style={{ 
              position: 'absolute', 
              bottom: '0', 
              left: '0', 
              width: '100%', 
              background: 'rgba(0, 0, 0, 0.8)', 
              padding: '10px', 
              display: 'flex', 
              justifyContent: 'space-between' 
            }}
          >


            <button 
              style={{color: 'white', display: 'flex', alignItems: 'center'}} 
              onClick={() => openOriginalImagem(`https://qth-files.s3.sa-east-1.amazonaws.com/${photo.filename}`)}
            >
              Abrir original &nbsp; <BiLinkExternal />

            </button>
            <button 
              style={{color: 'white', display: 'flex', alignItems: 'center'}}  
              onClick={downloadImage}>
                Download &nbsp; <BiDownload />
              </button>
          </div>
        )}
      </div>

      


      

      
      <Text lineHeight='1.1' fontSize='sm' color="white" mt={1}>Latitude: <strong>{photo.latitude}</strong></Text>
      <Text lineHeight='1.1' fontSize='sm' color="white">Longitude: <strong>{photo.longitude}</strong></Text>

      <Button onClick={() => openModal()} color="white" style={{margin: '0px', padding: '0px', fontSize:'12px'}}>
        <Icon as={MdLocationOn} fontSize="20" color="white" /> Ver no mapa
      </Button>
    </div>
    
  )
}